import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import particles from 'particles.js'
import firebase from 'firebase'
import vuefire from 'vuefire'
import vuex from 'vuex'
import { routes } from './routes'


Vue.use(particles);

Vue.use(vuex);

Vue.use(firebase/app);

Vue.use(vuefire);

Vue.use(Vuelidate);

Vue.use(VueRouter);
const router = new VueRouter({
	mode: 'history',
  routes
});






new Vue({
  el: '#app',
  router,  
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js